export default {
  contactType: null,
  contacts: null,
  loading: false,
}
